/* 採用LP プライバシーポリシー フロントJS（ナビ開閉のみ） */
/* mobile menu toggle */
(function(){
  const burger = document.getElementById('navBurger');
  const navMobile = document.getElementById('navMobile');
  const overlay = document.getElementById('navMobileOverlay');
  if (!burger || !navMobile || !overlay) return;

  function setOpen(open){
    burger.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    navMobile.classList.toggle('open', open);
    navMobile.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.classList.toggle('show', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('nav-locked', open);
  }

  burger.addEventListener('click', () => setOpen(!navMobile.classList.contains('open')));
  overlay.addEventListener('click', () => setOpen(false));
  const closeBtn = document.getElementById('navMobileClose');
  if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
  navMobile.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => setOpen(false));
  });
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape' && navMobile.classList.contains('open')) setOpen(false);
  });
})();
